import { getDataLayer } from './utils';
import { buildInteractionEvent } from './GA4EventBuilder';

export const handleTracking = (eventType, payload = {}) => {
  getDataLayer().push(
    buildInteractionEvent(eventType, {
      ...payload,
      page: window.location.pathname
    })
  );
};
